import React from 'react';
import { List } from 'antd-mobile';
import { isLiveScorer, getNickname, isLiveInProgress, isDemo, getUserProfile } from '../../../../helpers';
import _ from 'lodash';
import './Followers.css';
import {connect} from 'react-redux';
import PropTypes from 'prop-types'; 

class Followers extends React.Component {
    
    componentWillUnmount() {
        sessionStorage.removeItem("followers");   
    }

    livescorerWording(live) {
        if(isLiveScorer([live])) {
            return this.props.pageReducer === 'pastMatch' ? 'Tu étais Live Scorer pour ce match !' : 'Tu es Live Scorer pour ce match !';
        }
        else {
            const nickname = live && !_.isEmpty(live) && live.author ? getNickname(live.author.firstname, live.author.lastname, live.author.nickname) : '';
            if(sessionStorage.getItem('followers') === '1' && !isLiveInProgress(live)) {
                return `Tu vas suivre le live de ${nickname}` 
            }
            else
                return this.props.pageReducer === 'pastMatch' ? `${nickname} était live scorer sur ce match` : `${nickname} est ton live scorer`
        }
    }

    followerWording(live) {
        if(this.props.pageReducer === 'pastMatch') {
            if(live.subscribers && live.subscribers.length > 0) {
                return `${live.subscribers.length} spectateur${live.subscribers.length > 1 ? 's' : '' } ont suivi ce live`
            }
            else {
                return 'Aucun spectateur ont suivi ce live'
            }
        }
        else{
            if(live.subscribers && live.subscribers.length > 0 ) {
                const nb = isDemo(live) ? 78011 : live.subscribers.length;
                return isLiveScorer([live]) ? `${nb} spectateur${nb > 1 ? 's' : '' } inscrit${nb > 1 ? 's' : '' } à ton live` : `${nb}  spectateur${nb > 1 ? 's' : '' }`
            }
            else{
                return isLiveScorer([live]) ? 'Aucun spectateur inscrit à ton live pour le moment' : 'Aucun spectateur pour le moment'
            }
        }
    }

    render() {
        const {live} = this.props;
        return (
            <List>
                <List.Item
                    thumb={<div style={{width: '24px', height: '17px', paddingTop: '13px', paddingLeft: '9px', paddingBottom: '11px'}} className='thumb-profile'>{ !_.isEmpty(live) && live.author && getUserProfile(live.author.firstname, live.author.lastname, live.author.nickname)}</div>}
                    wrap
                >
                    <div className='common' style={{fontSize: '12px', paddingTop: '5px', paddingBottom: '5px'}}>
                        {this.livescorerWording(live)}
                        <div style={{fontWeight: '700'}}>{ !_.isEmpty(live) && this.followerWording(live)}</div>
                    </div>
                </List.Item>
            </List>
        )
    }
}

const mapStateToProps = ({pageReducer}) => ({pageReducer});

Followers.propTypes = {
    pageReducer: PropTypes.string.isRequired,
    live: PropTypes.shape({
        author: PropTypes.shape({
            firstname: PropTypes.string,
            lastname: PropTypes.string,
            nickname: PropTypes.string
        }),
        subscribers: PropTypes.array
    }).isRequired
}

export default connect(mapStateToProps)(Followers);